import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { logoutRequest } from './operations'
import { LogoutIcon } from '../icons/LogoutIcon'
import { AppContext } from '../App'

const LogoutButton = () => {
  const { dispatch } = useContext(AppContext)
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logoutRequest(dispatch)
    navigate('/')
  }

  return (
    <div className='flex flex-col items-center'>
      <button className='mt-4 text-xs flex items-center gap-2' onClick={handleLogout}>
        <LogoutIcon />
        Logout
      </button>
    </div>
  )
}

export { LogoutButton }
